import React from 'react';

const Netball = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='13.999'
            viewBox='0 0 14 13.999'
            className={className}
        >
            <g id='Netball' transform='translate(-54.838 -367.902)'>
                <path
                    id='Path_3122'
                    data-name='Path 3122'
                    d='M60.742,380.776l-.212-.027a3.734,3.734,0,0,1-.51-.082c-.381-.094-.759-.2-1.137-.314a10.49,10.49,0,0,0,3.563-2.057,10.683,10.683,0,0,0,2.718-3.642l.047.025c.177.092.352.182.521.28a10.242,10.242,0,0,1,1.941,1.461,7.933,7.933,0,0,1-1.346,2.085,6.956,6.956,0,0,1-2.657,1.808,6.787,6.787,0,0,1-2.065.447l-.09.016Z'
                    transform='translate(0.674 1.125)'
                />
                <path
                    id='Path_3123'
                    data-name='Path 3123'
                    d='M67.623,375.722a10.435,10.435,0,0,0-4.994-2.271c-.374-.063-.756-.09-1.136-.115l-.17-.012a7.529,7.529,0,0,1-1.032-2.617l.093-.006c.246-.014.492-.029.738-.029a9.84,9.84,0,0,1,6.38,2.3c.23.19.355.336.358.567a1.436,1.436,0,0,0,.051.31l.019.99-.112.787-.038.23Z'
                    transform='translate(0.908 0.461)'
                />
                <path
                    id='Path_3124'
                    data-name='Path 3124'
                    d='M55.748,378.013a6.886,6.886,0,0,1-.737-1.927c-.042-.222-.071-.445-.1-.666l-.044-.328-.028-.126.006-.852.031-.237c.022-.191.046-.383.079-.57a6.831,6.831,0,0,1,1.615-3.373,11.118,11.118,0,0,0,1.982,6.8l-.142.084c-.262.16-.524.316-.792.461a9.046,9.046,0,0,1-1.869.738Z'
                    transform='translate(0 0.338)'
                />
                <path
                    id='Path_3125'
                    data-name='Path 3125'
                    d='M67.207,371.848a10.342,10.342,0,0,0-5.839-1.806,11.582,11.582,0,0,0-1.179.062,11.439,11.439,0,0,1,.1-2.151l.279-.051.751,0,.317.043c.225.027.45.055.673.1a6.8,6.8,0,0,1,3.459,1.8A6.7,6.7,0,0,1,67.207,371.848Z'
                    transform='translate(0.889 0)'
                />
                <path
                    id='Path_3126'
                    data-name='Path 3126'
                    d='M57.684,379.628a5.862,5.862,0,0,1-1.186-.966c-.107-.123-.209-.249-.309-.373l.212-.082c.386-.149.762-.293,1.123-.464a10.265,10.265,0,0,0,4.352-3.837l.112-.065a9.539,9.539,0,0,1,2.657.481l-.064.125c-.131.259-.26.518-.407.766a9.529,9.529,0,0,1-3.153,3.266,9.27,9.27,0,0,1-3.172,1.261Z'
                    transform='translate(0.225 0.989)'
                />
                <path
                    id='Path_3127'
                    data-name='Path 3127'
                    d='M59,376.254c-.141-.207-.28-.409-.407-.621a9.509,9.509,0,0,1-1.211-6.456,7.024,7.024,0,0,1,2.269-1.044c-.015.131-.029.259-.04.387a9.976,9.976,0,0,0,1.19,5.693A8.643,8.643,0,0,1,59.2,376.2l-.155.134Z'
                    transform='translate(0.401 0.039)'
                />
            </g>
        </svg>
    );
};

export default Netball;
